export default __webpack_public_path__ + "static/media/logo.edf95a7b.svg";